import {
  AppBar,
  Avatar,
  Box,
  Container,
  Toolbar,
  Typography,
} from "@mui/material";
import avatar from "../images/avatar.png";

function Header() {
  return (
    <AppBar position="static">
      <Container>
        <Toolbar>
          <Typography
            variant="h5"
            noWrap
            sx={{
              mr: 2,
              display: "flex",
              flexGrow: 1,
              fontFamily: "Amatic SC",
              color: "inherit",
              textDecoration: "none",
            }}
          >
            Amirah Nasihah
          </Typography>

          <Box sx={{ flexGrow: 0 }}>
            <Avatar alt="Amirah Nasihah" src={avatar} />
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default Header;
